module.exports = __webpack_public_path__ + "static/media/logo.cbb7044c.svg";